import {Link, NavLink, useLocation} from 'react-router'
import {useTranslation} from 'react-i18next'
import {SupportedLanguage} from '~/utils/locales'
import {useLocalizedPath} from '~/utils/useLocalizedPath'
import {getWebsiteSearchParams} from '~/utils/url'
import {buildSearchParams, TWebsiteLinkProps} from './utils'

export const TWebsiteLink = ({
  to,
  queryParams,
  customLocale,
  noRedirect,
  isNav,
  className,
  ...props
}: TWebsiteLinkProps) => {
  const localizedTo = useLocalizedPath(to, customLocale)
  const {i18n} = useTranslation()
  const {search} = useLocation()
  const {noRedirect: noRedirectFromSearch} = getWebsiteSearchParams(search) || {}

  const effectiveLocale = customLocale || (i18n.language as SupportedLanguage)
  const finalNoRedirect = noRedirect || noRedirectFromSearch

  const {searchString} = buildSearchParams({
    queryParams,
    isAppUrl: false,
    locale: effectiveLocale,
    noRedirect: finalNoRedirect
  })
  const rel = props.target === '_blank' ? 'noopener noreferrer' : undefined

  const linkData = {pathname: localizedTo, search: searchString}

  if (isNav) return <NavLink {...props} to={linkData} className={className} />
  return <Link {...props} to={linkData} rel={rel} className={className} />
}
